module.exports = __webpack_public_path__ + "c44e5b3c464fa741063fd0757ba14906.svg";